import { AccountAuditLogsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/audit-logs')({
  component: AccountAuditLogsRoute,
});
